

import { useNavigate } from 'react-router-dom';
import Navigation from '@/components/landing/Navigation';
import Footer from '@/components/landing/Footer';
import ContactHeader from '@/components/contact/ContactHeader';
import ContactCards from '@/components/contact/ContactCards';
import ContactFormContainer from '@/components/contact/ContactFormContainer';

const Contact = () => {

  
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleSignup = () => {
    navigate('/auth/signup');
  };

  return (
    <div className="bg-background min-h-screen">
      <Navigation onLogin={handleLogin} onSignup={handleSignup} />
      
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-6xl">
          <ContactHeader />
          <ContactCards />
          <ContactFormContainer />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Contact;
